import { usePassThrough } from 'primevue/passthrough';
import { button } from '../button';

export const splitbutton = {
  root: ({ props }: Record<string, any>) => ({
    class: [
      // Flexbox and Position
      'tw-flex',
      'tw-relative',

      // Shape
      'tw-rounded',
      { 'tw-shadow-lg': props.raised },
    ],
  }),
  pcButton: usePassThrough(
    button,
    {
      root: {
        class: ['tw-rounded-r-none tw-text-white !tw-border-none'],
      },
      label: {
        class: ['tw-truncate'],
      },
    },
    { mergeProps: true, mergeSections: true },
  ),
  pcDropdown: usePassThrough(
    button,
    {
      root: {
        class: ['tw-rounded-l-none !tw-px-2 tw-text-white !tw-border-none'],
        ariaLabel: 'dropdown',
      },
    },
    { mergeProps: true, mergeSections: true },
  ),
  pcMenu: {
    root: {
      class: [
        'tw-text-[16px] tw-font-sans tw-font-normal tw-text-black',

        'tw-min-w-[12rem]',
        'tw-py-0.5',

        'tw-z-overlay',
      ],
    },
    rootList: {
      class: ['tw-bg-white tw-border tw-border-grey-200 tw-rounded-md tw-shadow-md tw-p-1'],
    },
  },
};
